import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src="/assets/logo.png" alt="JuryView" className="footer-logo" />
            <p className="standards-line">
              {t('footer.tagline')}
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-section">
              <h4>Platform</h4>
              <ul>
                <li><Link to="/engine">{t('nav.engine')}</Link></li>
                <li><Link to="/applications">{t('nav.applications')}</Link></li>
                <li><Link to="/licensing">{t('nav.licensing')}</Link></li>
                <li><Link to="/integrations">{t('nav.integrations')}</Link></li>
                <li><Link to="/fact-finder">{t('nav.factFinder')}</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Company</h4>
              <ul>
                <li><Link to="/about">{t('nav.about')}</Link></li>
                <li><Link to="/contact">{t('nav.contact')}</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>{t('footer.legal')}</h4>
              <ul>
                <li><Link to="/privacy">{t('footer.privacy')}</Link></li>
                <li><Link to="/terms">{t('footer.terms')}</Link></li>
                <li><Link to="/security">{t('footer.security')}</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
